import { Panel } from '@assets/component/Panel/Panel';
import { PanelHeader } from '@assets/component/Panel/PanelHeader/PanelHeader';
import {
    PanelColumn,
    PanelRow,
    PanelTable
} from '@assets/component/Panel/PanelTable/PanelTable';
import { GetSectionIconUrl } from '@assets/component/SectionIcons/SectionIcon';
import { Flex } from '@assets/component/UI/Flex/Flex';
import { useStore } from '@assets/model/Store';
import { max, min } from 'lodash';
import { formatDollar, formatPercent } from '../../PanelElements/Formatters';
import { RowLabel } from '../../PanelElements/RowLable/RowLable';
import { RowValue } from '../../PanelElements/RowValue/RowValue';
import * as style from './PanelCustomers.module.less';
export const PanelCustomers = () => {
    const data = {};
    const query = useStore().query;

    const customers = query.customers;
    if (!customers) {
        return null;
    }

    const colPercent = {
        element: RowValue.percent,
        label: RowLabel.label,
        overrideFormatting: formatPercent
    };

    const rowDefaults = {
        element: RowValue.value,
        label: RowLabel.label,
        formatter: data => formatDollar(data.toString())
    };

    const getYearRange = () => {
        var minYear = 0;
        var maxYear = 0;
        const years = [];
        for (const customer of customers) {
            for (const k in customer.revenue) {
                const e = customer.revenue[k];
                if (e.year > 0) {
                    years.push(e.year);
                }
            }
        }

        return { minYear: min(years), maxYear: max(years) };
    };
    const ALL_YEAR_CUSTOMER_INDEX = -1;
    const { minYear, maxYear } = getYearRange();
    const customerOrder = customers
        .map((c, index) => ({ name: c.name, index }))
        .sort((a, b) => a.name.localeCompare(b.name))
        .map(c => c.index);

    customerOrder.push(ALL_YEAR_CUSTOMER_INDEX);

    const cols: PanelColumn[] = [];
    for (let i = minYear; i <= maxYear; i++) {
        cols.push({ column: { source: i.toString(), display: i.toString() } });
        cols.push({
            column: {
                source: i.toString(),
                display: i.toString() + '%'
            },
            overrideValue: (field, column) => {
                const year = parseInt(column.source);
                const customerIndex = parseInt(field.source);
                var rev = getCustomerRevenue(customerIndex, year);
                var totalRev = query.valueByYear('net_revenue_per_year', year);

                if (totalRev == 'N/A' || rev == 0) {
                    return '-';
                }

                return rev / totalRev;
            },
            ...colPercent
        });
    }

    cols.push({
        header: col => {
            return (
                <Flex fillCell={true} justify="start">
                    {col.column.display}
                </Flex>
            );
        },
        column: { source: null, display: 'Source' },
        element: RowValue.sources,
        dontUseRowFormatting: true,
        overrideValue: (field, column) => {
            const customerIndex = parseInt(field.source);
            const customer = customers[customerIndex];
            if (!customer) {
                return [];
            }

            return customer.page_sources;
        }
    });

    const getCustomerRevenue = (customerIndex: number, year: number) => {
        if (customerIndex === ALL_YEAR_CUSTOMER_INDEX) {
            return customers
                .flatMap(c => c.revenue)
                .filter(e => e.year === year)
                .reduce((acc, e) => acc + (e.revenue || 0), 0);
        }
        const customer = customers[customerIndex];
        if (!customer) {
            return 0;
        }

        return customer.revenue.find(e => e.year === year)?.revenue ?? 0;
    };

    const rows: PanelRow[] = [];
    for (let i in customerOrder) {
        const customerIndex = customerOrder[i];
        const customerName =
            customerIndex == ALL_YEAR_CUSTOMER_INDEX
                ? 'Totals'
                : customers[customerIndex].name;

        const row: PanelRow = {
            field: {
                source: customerIndex.toString(),
                display: customerName
            },
            value: (field, column) => {
                const year = parseInt(column.source);
                const customerIndex = parseInt(field.source);
                var rev = getCustomerRevenue(customerIndex, year);
                if (rev == 0) {
                    return '-';
                }
                return rev;
            },
            ...rowDefaults
        };
        rows.push(row);
    }

    const icon = GetSectionIconUrl('concentration');
    return (
        <>
            <Panel>
                <PanelHeader title="Customers" iconUrl={icon} />
                <PanelTable
                    className={style.panelTableStyle}
                    topLeftCellText="($ in Millions)"
                    columns={cols}
                    rows={rows}
                />
            </Panel>
        </>
    );
};
